"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabCarouselItem;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _merchButton = require("@site/pattern-library-core/merch-button");
var _image = require("@site/pattern-library-core/image");
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
const TabCarouselItemContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TabCarouselItemContainer",
  class: "pl-tzb6mp9",
  vars: {
    "tzb6mp9-0": [({
      active
    }) => active ? 'translateX(0)' : 'translateX(200%)'],
    "tzb6mp9-1": [({
      active
    }) => active ? 'transform 1s ease-in-out' : 'initial'],
    "tzb6mp9-2": [({
      active
    }) => active ? '1' : '0'],
    "tzb6mp9-3": [({
      active
    }) => active ? '100' : '0']
  }
});
const ContentContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ContentContainer",
  class: "pl-cxya6u4"
});

/**
 * TabCarouselItem Component
 *
 * @param {object} props React props
 * @param {string} props.id Id
 * @param {object} props.image Tab feature image object
 * @param {heading} props.heading Heading text
 * @param {node} props.description Description
 * @param {node} props.cta Cta object
 * @param {boolean} props.active True if active tab, otherwise false
 * @param {boolean} props.slideAnimation True to use slide animation, false to use fade in
 * @returns {React.ReactElement} TabCarouselItem Component
 * @public
 */
function TabCarouselItem({
  id,
  image,
  heading,
  description,
  cta,
  active,
  slideAnimation = true
}) {
  return /*#__PURE__*/_react.default.createElement(TabCarouselItemContainer, {
    id: id,
    active: active,
    "data-animation": slideAnimation ? 'slide' : 'fade-in',
    "data-cy": "tab-carousel-item"
  }, image && /*#__PURE__*/_react.default.createElement(_image.LazyImage, {
    url: image.url,
    altText: image.altText,
    "data-cy": "tab-feature-image"
  }), /*#__PURE__*/_react.default.createElement(ContentContainer, {
    "data-cy": "tab-feature-content"
  }, (heading || description) && /*#__PURE__*/_react.default.createElement(_index.default, {
    heading: heading,
    description: description,
    textAlign: "center",
    headlineTag: "h3",
    headlineLineLength: 2.25
  }), cta && /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, cta)));
}
TabCarouselItem.propTypes = {
  id: _propTypes.default.string,
  tabTitle: _propTypes.default.string,
  ariaLabel: _propTypes.default.string,
  image: _propTypes.default.shape(_image.imgPropShape),
  heading: _propTypes.default.string,
  description: _propTypes.default.node,
  cta: _propTypes.default.shape(_merchButton.NSMerchButton.propTypes),
  active: _propTypes.default.bool,
  slideAnimation: _propTypes.default.bool
};